import { forwardRef } from "react";
import _ChipText, { _ChipTextProps } from "./_chip-text";

interface ChipOutlinedProps
  extends Omit<_ChipTextProps, "type">,
    Omit<React.HTMLAttributes<HTMLDivElement>, keyof _ChipTextProps> {}

const ChipOutlined = forwardRef<HTMLDivElement, ChipOutlinedProps>(
  (
    {
      size = "20px",
      rounded = false,
      leftIcon = null,
      showRightIcon = false,
      ...props
    },
    ref,
  ) => {
    return (
      <_ChipText
        type="outlined"
        size={size}
        rounded={rounded}
        leftIcon={leftIcon}
        showRightIcon={showRightIcon}
        ref={ref}
        {...props}
      />
    );
  },
);

ChipOutlined.displayName = "ChipOutlined";

export default ChipOutlined;
